<template>
  <div class="dashboard">
    <span>{{ $t('dashboard.guide.title') }}</span>

    <!--  新手指引  -->
    <div class="content">
      <div class="content_item">
        <img src="../image/guideOne.png">
        <div>
          <p>{{ $t('dashboard.guide.createTeam') }}</p>
          <span>{{ $t('dashboard.guide.createTeamDesc') }}<span @click="toCourse">{{ $t('dashboard.guide.viewDetails') }}</span></span>
        </div>
      </div>
      <div class="content_item">
        <img src="../image/guideThree.png">
        <div>
          <p>{{ $t('dashboard.guide.loginNode') }}</p>
          <span>{{ $t('dashboard.guide.loginNodeDesc') }}<span @click="toCourse">{{ $t('dashboard.guide.viewDetails') }}</span></span>
        </div>
      </div>
      <div class="content_item">
        <img src="../image/guideTwo.png">
        <div>
          <p>{{ $t('dashboard.guide.submitTask') }}</p>
          <span>{{ $t('dashboard.guide.submitTaskDesc') }}
            <span @click="toCourse">{{ $t('dashboard.guide.viewDetails') }}</span></span>
        </div>
      </div>
    </div>

    <!--  创建节点按钮组  -->
    <div class="btn_group">
      <div v-if="projectListLength === 0">
        <el-button @click="createTeam">{{ $t('dashboard.guide.createTeamBtn') }}</el-button>
        <el-button type="primary" @click="addTeam">{{ $t('dashboard.guide.joinTeamBtn') }}</el-button>
      </div>
      <el-button
        v-else
        :type="registerNode ? 'primary': ''"
        :disabled="!registerNode"
        @click="runNode"
        :style="registerNode ? 'background: #0052D9;':''"
      >{{ $t('dashboard.guide.loginNodeBtn') }}</el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { ENV_STATUS_SUCCESS } from '@/common/constants';

export default {
  name: 'statistics',
  data() {
    return {
      currentProject: {}, // 当前项目信息
      projectListLength: 0, // 项目列表长度
      registerNode: false, // 是否登录节点
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.projectList'(val) {
      this.projectListLength = val.length;
    },
    'app.currentProject': {
      immediate: true,
      handler(val) {
        if (val && val.env.status) {
          this.registerNode = val.env.status === ENV_STATUS_SUCCESS;
        }
      },
    },
  },
  created() {
    this.projectListLength = this.app.projectList.length;
    // let currentProject = this.getCurrentProject() || {};
  },
  methods: {
    // 创建团队
    createTeam() {
      this.$store.commit('app/setTeamIsShow', {
        isShow: true,
        action: 'createTeam',
      });
    },

    // 加入团队
    addTeam() {
      this.$emit('click');
    },

    // 登录节点
    runNode() {
      // const res = this.getCurrentProject();
      window.open('/remoteDestop');
    },

    // 查看详细流程
    toCourse() {
      window.open('https://doc.weixin.qq.com/doc/w3_AHAAVwaRACkz0danLW7R1SytpCpM3?scode=AJEAIQdfAAoK1XWJ54AHAAVwaRACk');
    },
  },
  beforeDestroy() {
    this.$off('click');
  },
};
</script>

<style scoped lang="scss">
// 仪表盘样式
.dashboard {
  background: #FFFFFF;
  padding: 10px 25px 25px;
  min-width: 994px;

  // 弹窗头部样式
  ::v-deep .el-dialog__header {
    padding-bottom: 20px;
    color: rgba(0,0,0,1);
    font-weight: 400;
    font-family: "PingFang SC";
    span {
      font-size: 16px;
    }
  }

  // 弹窗主体样式
  ::v-deep .el-dialog__body {
    padding-top: 10px;
    color: rgba(0,0,0,1);
    font-weight: 400;
    font-size: 16px;
    font-family: "PingFang SC";
  }
}

// 主体内容样式
.content {
  padding:50px 25px 0;
  display: flex;
  justify-content: space-between;
}
// 按钮样式
.el-button {
  width: 112px;
  height: 40px;
  padding: 0;
}
// 按钮组样式
.btn_group {
  padding-top: 22px;
  text-align: center;
}

// 主体内容每一个item样式
.content_item {
  width: 30%;
  font-size: 12px;
  img {
    width: 100%;
  }
  p {
    text-align: center;
    font-size: 14px;
  }
  span :last-child {
    color: rgba(0,82,217,1);
    cursor: pointer;
  }
}

.color_0052D9 {
  color: #0052D9;
}
</style>
